var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1213_21185)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.977 2.771L7.768 6.98C7.29869 7.44812 6.66287 7.71102 6 7.71102C5.33713 7.71102 4.70131 7.44812 4.232 6.98L0.023 2.771C0.016 2.85 0 2.9215 0 3V9C0.000793929 9.66279 0.264441 10.2982 0.73311 10.7669C1.20178 11.2356 1.8372 11.4992 2.5 11.5H9.5C10.1628 11.4992 10.7982 11.2356 11.2669 10.7669C11.7356 10.2982 11.9992 9.66279 12 9V3C12 2.9215 11.984 2.85 11.977 2.771Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.06107 6.273L11.6281 1.7055C11.4068 1.33866 11.0948 1.03502 10.7221 0.823865C10.3493 0.612712 9.92846 0.50117 9.50007 0.5H2.50007C2.07168 0.50117 1.65082 0.612712 1.27808 0.823865C0.905346 1.03502 0.59331 1.33866 0.37207 1.7055L4.93907 6.273C5.22086 6.55366 5.60236 6.71123 6.00007 6.71123C6.39778 6.71123 6.77928 6.55366 7.06107 6.273Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1213_21185"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailWhite);
export default __webpack_public_path__ + "static/media/email-white.38039b81eb03beff5daf0f5b59b6cd8d.svg";
export { ForwardRef as ReactComponent };